export default "__VITE_ASSET__BKPvMKWr__"